/**
 * 工作台左栏宽度照 DeeVid（2026-10-18 量的）：默认 412，拖动夹在 332–592，跟视口宽度无关；
 * 松手存进 localStorage，下次打开还是这个宽。
 * 这是含边距的总宽。DeeVid 的 380 / 300–560 是内容宽、边距 16，我们边距也是 16，
 * 所以总宽各加 32（10/19 对比页第 11 项；之前照抄 380 当总宽，内容只有 332）。
 *
 * 宽度挂在 <html> 的 CSS 变量上，(saas) layout 的内联脚本在首帧前从 localStorage 读出来写上：
 * 页面是静态预渲染，服务端不知道存的宽度，等 React 跑完再设，拖过的人刷新时左栏会先按默认宽画再跳宽。
 * 和 AUTH_HINT_SCRIPT 同一个做法。
 */
export const LEFT_PANEL_WIDTH = { min: 332, max: 592, default: 412 } as const;
/** 左栏读宽度用的 CSS 变量，只在分栏起生效（globals.css 的 studio-split；手机上下堆叠，左栏通栏） */
export const LEFT_PANEL_WIDTH_VAR = "--left-panel-w";
export const LEFT_PANEL_WIDTH_STORAGE_KEY =
	"ai-image-generator:left-panel-width";

export const clampLeftPanelWidth = (width: number) =>
	Math.max(
		LEFT_PANEL_WIDTH.min,
		Math.min(LEFT_PANEL_WIDTH.max, Math.round(width)),
	);

export const LEFT_PANEL_WIDTH_SCRIPT = `try{var w=Math.round(+localStorage.getItem("${LEFT_PANEL_WIDTH_STORAGE_KEY}"));w&&document.documentElement.style.setProperty("${LEFT_PANEL_WIDTH_VAR}",Math.max(${LEFT_PANEL_WIDTH.min},Math.min(${LEFT_PANEL_WIDTH.max},w))+"px")}catch(e){}`;

export function setLeftPanelWidthVar(width: number) {
	document.documentElement.style.setProperty(
		LEFT_PANEL_WIDTH_VAR,
		`${width}px`,
	);
}
